var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_18_87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0955 7.17467C28.2011 7.55805 27.2385 7.81665 26.2285 7.93238C27.2598 7.33707 28.0505 6.3941 28.4234 5.2692C27.4588 5.82117 26.391 6.22169 25.2536 6.43791C24.3434 5.50256 23.0459 4.91772 21.6102 4.91772C18.8538 4.91772 16.6189 7.07275 16.6189 9.73118C16.6189 10.1079 16.6629 10.4751 16.7483 10.828C12.5997 10.627 8.92121 8.71105 6.45917 5.79879C6.02949 6.50935 5.78353 7.33612 5.78353 8.21908C5.78353 9.88881 6.66463 11.3623 8.00405 12.2253C7.18618 12.2001 6.4162 11.9834 5.74304 11.6228C5.74254 11.6428 5.74254 11.6633 5.74254 11.6838C5.74254 14.0155 7.46325 15.9605 9.74699 16.4034C9.32817 16.513 8.88713 16.572 8.43176 16.572C8.10975 16.572 7.79712 16.542 7.49239 16.4853C8.12802 18.3975 9.97121 19.7896 12.1552 19.8281C10.4468 21.1192 8.29496 21.8889 5.9559 21.8889C5.55338 21.8889 5.1558 21.866 4.76514 21.8212C6.97479 23.1876 9.59833 23.9839 12.4169 23.9839C21.5988 23.9839 26.6192 16.6496 26.6192 10.2889C26.6192 10.0803 26.6147 9.87215 26.6054 9.66545C27.5803 8.98823 28.4268 8.14003 29.0955 7.17467Z",
    fill: "#7D7D7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_18_87",
    x: -1,
    y: 0,
    width: 36,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18_87"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18_87",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwit);
export default __webpack_public_path__ + "static/media/twit.a6e59a7ef5fa9718a56c6c59097d74f8.svg";
export { ForwardRef as ReactComponent };